module.exports = __webpack_public_path__ + "static/media/monarxShield.078be1dc.svg";